export function initMisc() {
  document.querySelector(".cta-button").addEventListener("click", () => {
    document.querySelector("#card-section").scrollIntoView({
      behavior: "smooth",
    });
  });
}
